import { merge } from 'lodash';

const defaultArgs = {};

const defaultAttrs = {
  pendingFirstIndex: true,
  pendingFlake: true,
  id: true,
  stakedFlake: true,
  user: true,
  veFlakeBalance: true
};

export default (args = {}, attrs = {}) => ({
  userFlakeInfos: {
    __args: merge({}, defaultArgs, args),
    ...merge({}, defaultAttrs, attrs)
  }
});
